var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgProgramme = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3473 3.89375L25.214 7.38708C27.4807 8.38708 27.4807 10.0404 25.214 11.0404L17.3473 14.5338C16.454 14.9338 14.9873 14.9338 14.094 14.5338L6.22734 11.0404C3.96068 10.0404 3.96068 8.38708 6.22734 7.38708L14.094 3.89375C14.9873 3.49375 16.454 3.49375 17.3473 3.89375Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.666C4 15.786 4.84 17.0793 5.86667 17.5327L14.92 21.5593C15.6133 21.866 16.4 21.866 17.08 21.5593L26.1333 17.5327C27.16 17.0793 28 15.786 28 14.666",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.334C4 22.574 4.73333 23.694 5.86667 24.2007L14.92 28.2273C15.6133 28.534 16.4 28.534 17.08 28.2273L26.1333 24.2007C27.2667 23.694 28 22.574 28 21.334",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProgramme, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/programme.5af5e980.svg";
export { ForwardRef as ReactComponent };